<template>
  <div>
    <table class="table is-fullwidth">
      <tbody>
        <tr>
          <th width="20%">{{ $t("Email") }}</th>
          <td>{{ user.userId }}</td>
        </tr>
        <tr>
          <th>{{ $t("Name") }}</th>
          <td>{{ user.userName }}</td>
        </tr>
        <tr>
          <th>{{ $t("profile.userRole") }}</th>
          <td>
            <span v-if="user.userRole == 'admin'">
              {{ $t("profile.admin") }}
            </span>
            <span v-else>
              {{ $t("profile.user") }}
            </span>
          </td>
        </tr>
        <tr>
          <th>{{ $t("auth.startMfa") }}</th>
          <td>
            <span v-if="user.mfa">{{ $t("Enable") }}</span>
            <span v-else>{{ $t("Disable") }}</span>
          </td>
        </tr>
        <tr>
          <th>{{ $t("users.lastLogin") }}</th>
          <td>{{ user.lastLogin }}</td>
        </tr>
        <tr>
          <th>{{ $t("Created_at") }}</th>
          <td>{{ user.created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
